import React from "react";
import { StyleSheet, View } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { FilterChip } from "./FilterChip";
import { useThemeColor } from "@/hooks/useThemeColor";
import { IMessageFilterCriteria } from "common247";

export interface IMessageFilterComponentProps {
  criteria: IMessageFilterCriteria;
  onChange: (updated: IMessageFilterCriteria) => void;
}

const FOLDERS = [
  { key: "all", label: "All Folders" },
  { key: "inbox", label: "Inbox" },
  { key: "sent", label: "Sent" },
  { key: "trash", label: "Trash" },
];

const READ_STATUSES = [
  { key: "all", label: "All Status" },
  { key: "unread", label: "Unread Only" },
  { key: "read", label: "Read Only" },
];

/**
 * Filter controls specific to the Messages list.
 */
export function MessageFilter({
  criteria,
  onChange,
}: IMessageFilterComponentProps): React.JSX.Element {
  const textMuted = useThemeColor({}, "textMuted");

  const currentFolder = criteria.folder || "all";
  const currentReadStatus = criteria.readStatus || "all";

  return (
    <View style={styles.container}>
      {/* Folder */}
      <View style={styles.section}>
        <ThemedText style={[styles.label, { color: textMuted }]}>Folder</ThemedText>
        <View style={styles.chipsWrap}>
          {FOLDERS.map((f) => (
            <FilterChip
              key={f.key}
              label={f.label}
              selected={currentFolder === f.key}
              onPress={() => onChange({ ...criteria, folder: f.key as any })}
              compact
            />
          ))}
        </View>
      </View>

      {/* Read Status */}
      <View style={styles.section}>
        <ThemedText style={[styles.label, { color: textMuted }]}>Read Status</ThemedText>
        <View style={styles.chipsWrap}>
          {READ_STATUSES.map((s) => (
            <FilterChip
              key={s.key}
              label={s.label}
              selected={currentReadStatus === s.key}
              onPress={() => onChange({ ...criteria, readStatus: s.key as any })}
              compact
            />
          ))}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 4,
  },
  section: {
    marginBottom: 8,
  },
  label: {
    fontSize: 12,
    fontWeight: "600",
    marginBottom: 4,
  },
  chipsWrap: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
});
